import { Achievement, AchievementType } from '@breath-lab/types';

export const ACHIEVEMENT_GROUP_ORDER: AchievementType[] = [
  AchievementType.personalBest,
  AchievementType.trophy,
  AchievementType.medal,
  AchievementType.streak,
  AchievementType.totals,
];

export function achievementGroupLabel(type: AchievementType): string {
  switch (type) {
    case AchievementType.personalBest: return 'Personal Bests';
    case AchievementType.trophy: return 'Trophies';
    case AchievementType.medal: return 'Medals';
    case AchievementType.streak: return 'Streaks';
    case AchievementType.totals: return 'Totals';
  }
}

export function groupAchievementsByType(achievements: Achievement[]): Map<AchievementType, Achievement[]> {
  const map = new Map<AchievementType, Achievement[]>();
  for (const type of ACHIEVEMENT_GROUP_ORDER) {
    map.set(type, []);
  }
  for (const achievement of achievements) {
    const group = map.get(achievement.type);
    if (group) group.push(achievement);
  }
  // Sort each group by position
  for (const [, group] of map) {
    group.sort((a, b) => a.position - b.position);
  }
  return map;
}
